// extracted by mini-css-extract-plugin
export var actions = "_1z-0";
export var actionsContainer = "_1z-7";
export var border = "_1z-1";
export var childFullHeight = "_1z-g";
export var collapse = "_1z-2";
export var content = "_1z-b";
export var contentChild = "_1z-f";
export var fullscreen = "_1z-d";
export var hasLeftRadius = "_1z-l";
export var headerContainer = "_1z-3";
export var headerRow = "_1z-5";
export var hidePadding = "_1z-c";
export var navCollapsedGap = "_1z-m";
export var noScrollX = "_1z-n";
export var noScrollY = "_1z-o";
export var noTopPadding = "_1z-j";
export var optOutTopPadding = "_1z-e";
export var pageMain = "_1z-k";
export var pageOuter = "_1z-h";
export var pagePadding = "_1z-8";
export var pageScroll = "_1z-9";
export var profile = "_1z-p";
export var profileContainer = "_1z-q";
export var profileImage = "_1z-r";
export var profileMain = "_1z-s";
export var profileSubtitle = "_1z-u";
export var profileTitle = "_1z-t";
export var settingsSurface = "_1z-a";
export var showLeftPadding = "_1z-i";
export var tabsPortalSlot = "_1z-6";
export var tabsWrapper = "_1z-4";
export var title = "_1z-v";